export default __webpack_public_path__ + "static/media/work-1right-1.cd5310c7.png";